/** The workshop's public contact address (contact page mailto + Organization JSON-LD). */
export const CONTACT_EMAIL = 'contact@basementpickups.com';
